import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LabelConfigModel } from '../objects/label-config-model';

@Pipe({
  name: 'fhLabelConfig'
})
export class FhLabelConfigPipe implements PipeTransform {
  constructor(private translateService: TranslateService,
              ) {}

  transform(formControls: any, formControlName: string, labelTranslation: string , currency:boolean=false, valuesArray?: { [key: string]: any }): LabelConfigModel {
    const config: LabelConfigModel = new LabelConfigModel();
    config.label = valuesArray ? this.translateService.instant(labelTranslation, valuesArray) : this.translateService.instant(labelTranslation);
    config.value = formControls[formControlName]?.value;
    config.type = 'STYLISH';
    config.currency = currency
    return config;
  }
}
